import React from 'react';
import './styles.sass';

import { ReactComponent as TurbiLogo } from 'components/base/svg/logo/1.svg';

const LoginBaseTemplate = props => {

  return (
    <>
    <div className="login-template">
      <div className="login-container">
        <TurbiLogo
          className="login-logo"
        />
        <div className="login-box">
          <div className="login-box__content">
            {props.children}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default LoginBaseTemplate;
